<template>
  <div>
    <div class="loader-overlay" v-if="this.$store.state.caller.isLoading">
      <div class="app-loader">
        <span class="loader"></span>
      </div>
    </div>
    <div class="page-header page-header-small clear-filter" filter-color="black">
      <parallax
        class="page-header-image"
        style="background-image: url('https://bucket-ctcloud.s3.sa-east-1.amazonaws.com/aws-cloudflare.webp')"
      >
      </parallax>
      <div class="content-center">
        <div class="container">
          <h1 class="title">Deploy no Amazon EC2 e CloudFlare.</h1>
          <div class="text-center">
            <a class="btn btn-primary btn-icon btn-round"
              v-on:click="evtShare">
              <i class="fas fa-share-alt"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Quem é você?</h2>
            <h5 class="description">
              Desenvolvedores e administradores de sistemas com conhecimento
              em deploy de aplicações, redes e gerenciamento de servidores.
            </h5>
            <h2 class="title">Qual será o resultado?</h2>
            <h5 class="description">
              Aprenda a criar servidores em nuvem, realizar o deploy de uma aplicação asp net core, configurar 
              sua VPC, crie e restaure snapshots, trabalhe com IPs elásticos. Aprenda a calcular e reduzir custos.
              Aponte DNS para o seu servidor pela CloudFlare.
            </h5>
          </div>
        </div>
        <div class="separator separator-primary"></div>        
      </div>
    </div>
    <div class="section section-team text-center">
      <div class="container">
        <h2 class="title">Como funciona</h2>
        <div class="team">
          <div class="row">
            <div class="col-md-3">
              <div class="team-player">
                <h3>1º passo</h3>
                <h4 class="title">Comunidade</h4>
                <p class="description">
                  Você será convidado para a comunidade da Cloud CT no Discord e
                  terá acesso aos canais para trocar experiências com outros alunos.
                </p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="team-player">
                <h3>2º passo</h3>
                <h4 class="title">Aulas</h4>
                <p class="description">
                  Realize o curso com carga horária de 24 horas com o professor Huander Tironi. 
                  As aulas são online em um período de 3 dias.
                </p>                
              </div>
            </div>
            <div class="col-md-3">
              <div class="team-player">
                <h3>3º passo</h3>
                <h4 class="title">Certificado</h4>
                <p class="description">
                  Receba seu certificado de participação. Emitido após a conclusão das
                  horas do curso.
                </p>                
              </div>
            </div>
            <div class="col-md-3">
              <div class="team-player">
                <h3>4º passo</h3>
                <h4 class="title">Oportunidades</h4>
                <p class="description">
                  Acompanhe as oportunidades na comunidade do discord.
                </p>                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section section-team text-center">
      <div class="container">
        <h2 class="title">Professor</h2>
        <div class="team">
          <div class="row">
            <div class="col-md-12">
              <div class="team-player">
                <img                  
                  src="https://bucket-ctcloud.s3.sa-east-1.amazonaws.com/huandertironi.jpg"
                  alt="Thumbnail Image"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title">Huander Tironi</h4>
                <p class="category text-primary">Mestre em Engenharia de Software</p>
                <p class="description">
                  Huander atua há 10 anos na área de Tecnologia da Informação.
                  Mestre pela PUC Curitiba na área de ciência da computação com ênfase
                  em Engenharia de Software. Especialista em Cloud Computing,
                  Desenvolvimento de Software. Cofundador da TARS Tecnologia. Professor 
                  de arquitetura de software e gestão de portfólios e projetos na PUC Paraná - Campus Londrina.
                </p>
                <a href="https://github.com/huandertironi" 
                  target="_blank"
                  class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-github"></i
                ></a>
                <a href="https://www.instagram.com/coding_tironi/" 
                   target="_blank" 
                   class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-instagram"></i
                ></a>
              </div>
            </div>            
          </div>
        </div>
      </div>
    </div>
    <div class="section section-contact-us text-center">
      <div class="container">
        <h2 class="title">Ficou interessado?</h2>
        <p class="description">Seu aprendizado é muito importante para nós.</p>
        <div class="row">
          <div class="col-lg-6 text-center ml-auto mr-auto col-md-8">
            <fg-input
              class="input-lg"
              placeholder="Nome"
              v-model="name"
              :validations="$v.name"
              addon-left-icon="now-ui-icons users_circle-08"
            >
            </fg-input>
            <fg-input
              class="input-lg"
              placeholder="Email"
              v-model="email"
              :validations="$v.email"
              addon-left-icon="now-ui-icons ui-1_email-85"
            >
            </fg-input>
            <fg-input
              class="input-lg"
              addon-left-icon="now-ui-icons tech_mobile"
              placeholder="Telefone"
              v-bind:mask="['(##) ####-####', '(##) #####-####']"
              v-model="phone"
              :validations="$v.phone"
              :contrast="true"
            >
            </fg-input>
            <div class="textarea-container">
              <textarea
                class="form-control"
                name="name"
                rows="4"
                cols="80"
                v-model="message"
                placeholder="Quais são as suas expectativas..."
              ></textarea>
            </div>
            <div class="send-button">
              <n-button type="primary" round block size="lg"
              v-on:click="evtCreateLead"
                >Estou interessado</n-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, FormGroupInput } from '@/components';
import { required, email } from "vuelidate/lib/validators";

export default {
  name: 'course-view',
  bodyClass: 'landing-page',
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data() {
    return {
      name: "",
      email: "",
      phone: "",
      message: "",
      courses: [
        {
          id: 'deploy-on-aws-ec2-and-cloudflare',
          header: 'https://bucket-ctcloud.s3.sa-east-1.amazonaws.com/aws-cloudflare.webp',
          name: 'Deploy no Amazon EC2 e CloudFlare.',
          whoYouAre: 'Desenvolvedores e administradores de sistemas com conhecimento em deploy de aplicações, redes e gerenciamento de servidores.',
          results: 'Aprenda a criar servidores em nuvem, realizar o deploy de uma aplicação asp net core, configurar sua VPC, crie e restaure snapshots, trabalhe com IPs elásticos. Aprenda a calcular e reduzir custos. Aponte DNS para o seu servidor pela CloudFlare.',
          description: 'Realize o curso com carga horária de 24 horas com o professor Huander Tironi. As aulas são online em um período de 3 dias.',
          professorName: 'Huander Tironi',
          professorTitle: 'Mestre em Engenharia de Software',
          professorCV: 'Huander atua há 10 anos na área de Tecnologia da Informação. Mestre pela PUC Curitiba na área de ciência da computação com ênfase em Engenharia de Software. Especialista em Cloud Computing, Desenvolvimento de Software. Cofundador da TARS Tecnologia. Professor de arquitetura de software e gestão de portfólios e projetos na PUC Paraná - Campus Londrina.',
          professorGithub: 'https://github.com/huandertironi',
          professorInstagram: 'https://www.instagram.com/coding_tironi/'
        }
      ]     
    };
  },
  methods: {
    evtCreateLead: async function () {
      
      if (!this.evtCheckForm())
        return false

      await this.$store.dispatch("lead/create", {
        data: this.evtGetForm(),
      });

      this.evtClearForm()
    },
    evtCheckForm: function () {
      
      let formValid = true

      this.$v.name.$touch()
      if (this.$v.name.$error === true)
        formValid = false

      this.$v.email.$touch()
      if (this.$v.email.$error === true)
        formValid = false

      this.$v.phone.$touch()
      if (this.$v.phone.$error === true)
        formValid = false

      return formValid

    },
    evtClearForm() {

      this.$v.$reset()
      this.name = ""
      this.phone = ""
      this.email = ""

    }, 
    evtGetForm() {
      let form = {
        Name: this.$data.name,
        Email: this.$data.email,
        Phone: this.$data.phone,
        Message: this.$data.message
      };

      return form;
    },
    async evtShare() {

      let firstCourse = this.courses[0]

      const shareData = {
        title: firstCourse.name,
        text: 'Aprenda sobre Cloud Computing com a CloudCT!',
        url: `https://cloudct.com.br/course${firstCourse.id}`
      }

      try {
        await navigator.share(shareData)
      } catch (err) {
        console.error(err)
      }


    }
  },
  validations: {
    name: { required },
    email: { required, email },
    phone: { required },
  }
};
</script>

<style scoped lang="scss">

.content-center {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    text-align: center;
    color: #fff;
    padding: 0 15px;
    width: 100%;
    max-width: 880px;
}



</style>
